import React, { useMemo } from 'react';
import { Table } from 'antd';
import { useSelector } from 'react-redux';

import { getColumns } from '../utils/getColumns';
import { dynamicPagination } from '../../../../../utils/common/dynamicPagination';
import {
    selectSelected,
    setSelectedRows,
    setSelectedRowsItem,
} from '../../../../common/store/selectionSlice';
import { useAppDispatch } from '../../../../../store';
import {
    PromocodeBase,
    PromocodeDTO,
    PromocodeFilters,
} from '../service/promocodes.interface';
import { PaginatedResponse } from '../../../../communities/interfaces/PaginatedResponse';

interface Props {
    filters: PromocodeFilters;
    source: PaginatedResponse<PromocodeDTO>;
    updateFilters: (update: Partial<PromocodeFilters>) => void;
    loading: boolean;
}

export const PromocodeTable = ({
    filters,
    source,
    updateFilters,
    loading,
}: Props) => {
    const dispatch = useAppDispatch();
    const { selectedRows } = useSelector(selectSelected);

    const pagination = useMemo(
        () => dynamicPagination(filters, updateFilters, source?.total, 'Всего'),
        [filters, updateFilters, source?.total]
    );

    const rowSelection = {
        selectedRowKeys: selectedRows,
        onChange: (keys: React.Key[], items: PromocodeBase[]) => {
            dispatch(setSelectedRows(keys as number[]));
            dispatch(setSelectedRowsItem(items));
        },
    };

    return (
        <Table
            rowSelection={rowSelection}
            loading={loading}
            columns={getColumns()}
            rowKey={record => record.id}
            dataSource={source?.items}
            pagination={pagination}
        />
    );
};
